/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BrowserCheckeredIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAqElEQVR4nO2VbQrCMAyG88tDid7AfPwpiSeyXsvhTdRrTCqjyDaKW6MD2QuBNIX3IQ00AKs+UQhhQ6JnZH2QWFsTKHonsZg8MyAVao1pGDEDOmrLrNuDHHelnCZ08t7Bq5hMmHVfymlCDADeARnA2nibo9gF/kcodnWfAWvzwyHL+MXc8/IAqjSmxQHg/UTYfXbOgNtXv2tkO/UWjsV+J7OMxxbOKijoCfP0SGH7jW9IAAAAAElFTkSuQmCC)
 */
export const BrowserCheckeredIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M4 3a3 3 0 0 0-3 3v2a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V6a3 3 0 0 0-3-3H4Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9 15h2v2H9v-2ZM13 15v2h2v-2h-2Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2 11a1 1 0 0 0-1 1v6a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1H2Zm5 4v-2H5v2h2Zm2 0H7v2H5v2h2v-2h2v2h2v-2h2v2h2v-2h2v2h2v-2h-2v-2h2v-2h-2v2h-2v-2h-2v2h-2v-2H9v2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
